import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {AmplitudeAuthLocation} from "../tracking/track_amplitude_auth_event";

interface IAmplitudeFlowTrackingSource {
    amplitudePlacement?: AmplitudeAuthPlacement | null;
    amplitudeLocation?: AmplitudeAuthLocation;
}

interface IAmplitudeFlowTracking<TPageLocation> {
    placement: AmplitudeAuthPlacement | null;
    location: AmplitudeAuthLocation | TPageLocation;
}

export const getAmplitudeFlowTracking = <TPageLocation>(
    flow: IAmplitudeFlowTrackingSource,
    pageLocation: TPageLocation
): IAmplitudeFlowTracking<TPageLocation> => ({
    placement: flow.amplitudePlacement ?? null,
    location: flow.amplitudeLocation ?? pageLocation
});
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {AmplitudeAuthLocation} from "../tracking/track_amplitude_auth_event";

interface IAmplitudeFlowTrackingSource {
    amplitudePlacement?: AmplitudeAuthPlacement | null;
    amplitudeLocation?: AmplitudeAuthLocation;
}

interface IAmplitudeFlowTracking<TPageLocation> {
    placement: AmplitudeAuthPlacement | null;
    location: AmplitudeAuthLocation | TPageLocation;
}

export const getAmplitudeFlowTracking = <TPageLocation>(
    flow: IAmplitudeFlowTrackingSource,
    pageLocation: TPageLocation
): IAmplitudeFlowTracking<TPageLocation> => ({
    placement: flow.amplitudePlacement ?? null,
    location: flow.amplitudeLocation ?? pageLocation
});
